import { defineComponent as _defineComponent } from 'vue'
import { PropType } from "vue";
import { IFullSeatLine } from "@/domain/entities/lineInfo";
import useGetLineRouteName from "@/use/useGetLineRouteName";
import LineSetTypeChip from "../shared/chip/LineSetTypeChip.vue";


const __default__ = {
  name: "FullSeatLineInfoRow",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  lineInfo: {
    type: Object as PropType<IFullSeatLine>,
    required: true,
  },
},
  emits: ["onClick"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();



const emit = __emit;

const emitOnClickLineInfo = (lineInfo: IFullSeatLine) => {
  emit("onClick", lineInfo);
};

const __returned__ = { emit, emitOnClickLineInfo, get useGetLineRouteName() { return useGetLineRouteName }, LineSetTypeChip }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})